import { Container, Grid, Typography } from "@mui/material";
import ScreenBanner from "../../../../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import { PaperBox } from "../../../../../components/Layout/PaperBox";
import AddIcon from '@mui/icons-material/Add';
import Listagem from "./Listagem";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export default function ListarChequesDevolvidos() {

    const listaAcoesRapidas: TItemAcaoRapida[] = [
        {
            label: "Incluir cheque",
            icon: <AddIcon color="primary" />,
            action: () => { },
            havePermission: usePermission('financeiro.cheques-incluir-cheque'),
            disabled: true
        }
    ]

    return (
        <>
            <ScreenBanner title="Financeiro" />
            <PermissionGuard permissionId="financeiro.cheques-listar-cheques-devolvidos">
                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5" mb={2}>Cheques</Typography>

                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                                fullHeight={false}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 9}}>
                            <PaperBox title="Lista de cheques devolvidos">
                                <Listagem />
                            </PaperBox>
                        </Grid>
                    </Grid>
                </Container>
            </PermissionGuard>
        </>
    )
}
